import type React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import type translations from "../../translations/translations.json";
import type { RootState } from "../../store";
import { useResetPassword } from "../../hooks/useResetPassword";
import ResetPasswordForm from "../ResetPasswordForm";

type TranslationKeys = keyof typeof translations.en;

const ProfilePasswordSection: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user.user);
  const { formData, loading, error, success, handleChange, handleSubmit } = useResetPassword({
    userId: user?._id || "",
  });

  if (!user) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t("Change Password" as TranslationKeys)}
      </Typography>
      <ResetPasswordForm
        formData={formData}
        loading={loading}
        error={error}
        success={success}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </Box>
  );
};

export default ProfilePasswordSection;
